import React from 'react';
import { IToast, ToastManager } from "../../fasades/toastmanager";
import { Toast } from './toast';
import './toastcontainer.css';

interface State {
    toasts : IToast[];
}

export class ToastContainer extends React.Component<{}, State> {

    constructor(props: {}) {
        super(props);
        this.state = {
            toasts : []
        };
    }

    componentDidMount()
    {
        ToastManager.onUpdate(this.handleUpdate.bind(this));
    }

    componentWillUnmount()
    {
        ToastManager.removeUpdateEvent(this.handleUpdate.bind(this));
    }

    handleUpdate(toasts : IToast[])
    {
        this.setState( { toasts : toasts });
    }

    render() {
        if (this.state.toasts.length === 0) 
            return null;

        return (
            <div className="toast-container">
                {this.state.toasts.map((toast) => (
                    <Toast
                        key={toast.id}
                        {...toast}
                    />
                ))}
            </div>
        );
    }
}

